(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bundle-builder"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  const bundleForm = document.getElementById('bundle-form');
  const pickButtons = document.querySelectorAll('.pick-button');
  const dropdowns = document.querySelectorAll('.dropdown');
  const dropdownItems = document.querySelectorAll('.dropdown-item');
  const selectedImages = document.querySelectorAll('.selected-product');
  const hiddenInputs = document.querySelectorAll('input[name="slots[]"]');
  const exitButtons = document.querySelectorAll('.exit-button');
  const bundleSubmitButton = document.querySelector('.bundle-submit button');

  // Function to close all dropdowns
  function closeAllDropdowns() {
    dropdowns.forEach(function(dropdown) {
      dropdown.classList.remove('visible');
      const pickButton = dropdown.parentElement.querySelector('.pick-button');
      pickButton.setAttribute('aria-expanded', 'false');
    });
  }

  // Handle button clicks to toggle dropdown visibility
  pickButtons.forEach(function(button) {
    button.addEventListener('click', function(e) {
      e.stopPropagation(); // Prevent event from bubbling up to document

      const slotNumber = this.getAttribute('data-slot');
      const dropdown = document.querySelector(`.dropdown[data-slot="${slotNumber}"]`);

      // Close other dropdowns
      closeAllDropdowns();

      // Toggle the visibility of the clicked dropdown
      const isVisible = dropdown.classList.toggle('visible');
      this.setAttribute('aria-expanded', isVisible);
    });

    // Allow opening dropdown with Enter or Space keys
    button.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        this.click();
      }
    });
  });

  // Handle clicking on a dropdown item
  dropdownItems.forEach(function(item) {
    item.addEventListener('click', function(e) {
      e.stopPropagation(); // Prevent event from bubbling up to document

      const variantId = this.getAttribute('data-variant-id');
      const imageUrl = this.getAttribute('data-image');
      const slotNumber = this.parentElement.getAttribute('data-slot');

      // Update the hidden input
      const hiddenInput = document.getElementById(`hidden-slot${slotNumber}`);
      hiddenInput.value = variantId;

      // Update and show the selected product image
      const selectedImage = document.querySelector(`.selected-product[data-slot="${slotNumber}"]`);
      selectedImage.src = imageUrl;
      selectedImage.style.display = 'block';

      // Show the exit button
      const exitButton = document.querySelector(`.exit-button[data-slot="${slotNumber}"]`);
      exitButton.style.display = 'flex';

      const pickButton = document.querySelector(`.pick-button[data-slot="${slotNumber}"]`);
      // pickButton.style.display = 'none';

      const dropdown = document.querySelector(`.dropdown[data-slot="${slotNumber}"]`);
      dropdown.classList.remove('visible');
      // pickButton.setAttribute('aria-expanded', 'false');

      scrollFunc();
    });

    // Allow selecting dropdown item with Enter key
    item.addEventListener('keydown', function(e) {
      if (e.key === 'Enter') {
        e.preventDefault();
        this.click();
      }
    });
  });

  function scrollFunc(){
     document.querySelector('.bundle-slots').scrollBy({
      left: 85, // Use a number instead of a string with 'px'
      behavior: 'smooth' // Options: 'auto' or 'smooth'
    });

  }


  // Handle exit button clicks to reset the slot
  exitButtons.forEach(function(button) {
    button.addEventListener('click', function(e) {
      e.stopPropagation(); // Prevent event from bubbling up to document

      const slotNumber = this.getAttribute('data-slot');

      // Clear the hidden input
      const hiddenInput = document.getElementById(`hidden-slot${slotNumber}`);
      hiddenInput.value = '';

      // Hide the selected image
      const selectedImage = document.querySelector(`.selected-product[data-slot="${slotNumber}"]`);
      selectedImage.src = '';
      selectedImage.style.display = 'none';

      // Hide the exit button
      this.style.display = 'none';

      // Show the "Pick a Pack" button
      const pickButton = document.querySelector(`.pick-button[data-slot="${slotNumber}"]`);
      pickButton.style.display = 'block';
    });
  });

  // Close dropdowns when clicking outside
  document.addEventListener('click', function() {
    closeAllDropdowns();
  });

  // Prevent dropdown from closing when clicking inside
  dropdowns.forEach(function(dropdown) {
    dropdown.addEventListener('click', function(e) {
      e.stopPropagation();
    });
  });

  // Handle form submission
  bundleForm.addEventListener('submit', function(e) {
    e.preventDefault();

    const selectedVariants = [];
    let allSelected = true;

    hiddenInputs.forEach(function(input) {
      if (!input.value) {
        allSelected = false;
      }
      selectedVariants.push({
        id: parseInt(input.value),
        quantity: 1
      });
    });

    if (!allSelected) {
      alert('Please select a product for each slot.');
      return;
    }

    // Disable the submit button to prevent multiple submissions
    bundleSubmitButton.disabled = true;
    bundleSubmitButton.textContent = 'Adding to Cart...';

    // Prepare the form data to add multiple items
    const formData = new FormData();

    selectedVariants.forEach(function(item, index) {
      formData.append(`items[${index}][id]`, item.id);
      formData.append(`items[${index}][quantity]`, item.quantity);
    });

    fetch('/cart/add', {
      method: 'POST',
      body: formData,
      credentials: 'same-origin'
    })
    .then(function(response) {
      if (!response.ok) {
        return response.text().then(function(text) {
          throw new Error(text);
        });
      }
      // Redirect to the cart page
      window.location.href = '/cart';
    })
    .catch(function(error) {
      console.error('Error adding products to cart:', error);
      alert('There was an error adding products to the cart. Please try again.');
    })
    .finally(function() {
      // Re-enable the submit button
      bundleSubmitButton.disabled = false;
      bundleSubmitButton.textContent = 'Add Bundle to Cart';
    });
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
